export const NOTIFICATION_ANIMATION_DURATION = 200

export const NOTIFICATION_GAP = '16px'

export const NOTIFICATION_EXIT_MAX_HEIGHT = '150px'

export const NOTIFICATION_MOTION_EASING = 'cubic-bezier(0.645, 0.045, 0.355, 1)'

export const NOTIFICATION_PLACEMENT = 'top'
